// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactDto
 */
export interface IContactDto {
    /**
     * 
     * @type {number}
     * @memberof IContactDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactDto
     */
    user_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDto
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IContactDto
     */
    is_primary?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IContactDto
     */
    role_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IContactDto
     */
    is_access_to_setup?: boolean;
}

/**
 * Check if a given object implements the IContactDto interface.
 */
export function instanceOfIContactDto(value: object): value is IContactDto {
    return true;
}

export function IContactDtoFromJSON(json: any): IContactDto {
    return IContactDtoFromJSONTyped(json, false);
}

export function IContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'is_primary': json['is_primary'] == null ? undefined : json['is_primary'],
        'role_id': json['role_id'] == null ? undefined : json['role_id'],
        'is_access_to_setup': json['is_access_to_setup'] == null ? undefined : json['is_access_to_setup'],
    };
}

export function IContactDtoToJSON(json: any): IContactDto {
    return IContactDtoToJSONTyped(json, false);
}

export function IContactDtoToJSONTyped(value?: IContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_name': value['user_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'email': value['email'],
        'phone': value['phone'],
        'is_primary': value['is_primary'],
        'role_id': value['role_id'],
        'is_access_to_setup': value['is_access_to_setup'],
    };
}

